<template>
    <router-link to="/tryouts" tag="li"
        ><a><i class="fa fa-pencil"></i><span>Tryout</span></a></router-link
    >
</template>

<script>
export default {
    name: "tryout-nav",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?03521e80